<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 7.25V8H1.46484L2.41992 8.95508L1.89258 9.48242L0.0351562 7.625L1.89258 5.76758L2.41992 6.29492L1.46484 7.25H12ZM9.58008 3.70508L10.5352 2.75H0V2H10.5352L9.58008 1.04492L10.1074 0.517578L11.9648 2.375L10.1074 4.23242L9.58008 3.70508Z" fill="#605E5C"/>
</svg>
